/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Redact_StepInputs */

const da_forside_redact_step = /** @type {(inputs: Forside_Redact_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du dækker navnet i browseren. Kun den dækkede PDF sendes.`)
};

/** @type {(inputs: Forside_Redact_StepInputs) => LocalizedString} */
const en_forside_redact_step = da_forside_redact_step;

/**

* @param {Forside_Redact_StepInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_redact_step = /** @type {((inputs?: Forside_Redact_StepInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Redact_StepInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_redact_step(inputs)
	return /** @type {LocalizedString} */ ("Du dækker navnet i browseren. Kun den dækkede PDF sendes.")
});